import { searchPageStore } from '../index'
import { initialThreeDOnlyState } from '../slices/threeDOnly'
import { initialThreeDPrintOnlyState } from '../slices/threeDPrintOnly'

/**
 * Sets the asset type and resets the secondary chips specific to each asset
 * type, so toggles don't persist when switching type and back.
 * @param {string} assetType - One of: "all", "3d_only", "3d_print_only"
 */
export const setAssetType = (assetType) => {
  if (searchPageStore.getState().assetType === assetType) return

  searchPageStore.setState({
    assetType,
    ...initialThreeDOnlyState,
    ...initialThreeDPrintOnlyState,
  })
}
